import { EditorContent } from "@tiptap/react";
import React from "react";
import toast from "../../components/Toast";
import { mediaApi } from "../../app-api/media";
import { EditorBox, EditorWrapper } from "./styled";

const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
const MAX_SIZE_MB = 10;

const getValidFiles = (files) =>
  Array.from(files).filter((file) => {
    if (!ALLOWED_TYPES.includes(file.type)) {
      toast({
        message: `"${file.name}" is not a valid file type. Please upload a JPEG or PNG.`,
        type: "error",
      });
      return false;
    }
    if (file.size / 1024 / 1024 > MAX_SIZE_MB) {
      toast({
        message: `"${file.name}" exceeds the 10MB size limit.`,
        type: "error",
      });
      return false;
    }
    return true;
  });

const insertImages = (editor, urls) => {
  const nodes = urls.map((url) => ({ type: "image", attrs: { src: url } }));
  editor
    .chain()
    .focus()
    .createParagraphNear()
    .insertContentAt(editor.state.selection.$anchor.pos, [
      { type: "paragraph" },
      ...nodes,
    ])
    .run();
};

const uploadAndInsert = async (editor, files) => {
  const validFiles = getValidFiles(files);
  if (!validFiles.length) return;

  const formData = new FormData();
  for (const file of validFiles) {
    formData.append(
      "images",
      file,
      file.name.split("(").join("_").split(")").join("_"),
    );
  }

  const label = validFiles.length === 1 ? "image" : "images";
  toast({
    message: `${validFiles.length} ${label} uploaded successfully!`,
    promise: {
      function: mediaApi.uploadImages(formData).then((res) => {
        if (res?.data?.preSignedUrls?.length) {
          insertImages(editor, res.data.preSignedUrls);
        }
      }),
      pending: { message: `Uploading ${validFiles.length} ${label}...` },
      error: { message: "Something went wrong. Please try again." },
    },
  });
};

const handleFileDrop = (editor, e) => {
  const files =
    "dataTransfer" in e ? e.dataTransfer?.files : e.clipboardData?.files;
  if (files?.length > 0) {
    e.preventDefault();
    uploadAndInsert(editor, files);
  }
};

const Editor = ({ editor }) => {
  if (!editor) return null;

  return (
    <EditorBox
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => handleFileDrop(editor, e)}
      onPaste={(e) => handleFileDrop(editor, e)}
    >
      <EditorWrapper>
        <EditorContent editor={editor} spellCheck="true" />
      </EditorWrapper>
    </EditorBox>
  );
};

export { uploadAndInsert };
export default Editor;
